import React, { useState, useEffect } from 'react';

const Checkbox = ({ label, name, checked, className, disabled, endIcon, onClick, value, ...props }) => {
  const [isChecked, setIsChecked] = useState(checked);
  const getClasses = disabled ? 'checkbox-disabled' : '';
  
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const onChange = (e) => {
    setIsChecked(!isChecked)
    onClick && typeof onClick ==='function' && onClick(e);
   }

  return (
      <>
          <label className={`checkbox-label ${className}  ${getClasses}`}  {...props}>
              <div className={`checkbox-label-inner ${isChecked ? 'border-purple-1' : 'border-grey-6'}`}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={onChange}
                    value={value}
                    className="bf-checkbox"
                    disabled={disabled}
                    name={name}/>  
                    <svg className={`checkbox-label-inner-svg ${isChecked ? 'bg-purple-1' :' bg-grey-6' } `}
                        viewBox="0 0 20 20">
                        <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                    </svg>
              </div>
              
              {label && <div className='text-black text-xs font-semibold leading-normal'>{label}</div>}
          </label>
          

      </>
    


   
  );
};


export default Checkbox;